export default "__VITE_ASSET__CQyaE8vz__"